<template>
    <form class="">
        <div class="form-group mb-3">
          <label for="attribute-name">
              Attribute Name
              <span class="text-danger">*</span>
          </label>
          <input type="text" v-validate="{required: true}" v-model="data.name" id="attribute-name" name="name" class="form-control"
          :class="{ 'is-invalid': errors.has('name') }" placeholder="Enter Name" />
          <span class="text-danger invalid-feedback"  v-show="errors.has('name')">{{ errors.first('name') }}</span>
        </div>
        <div class="form-group mb-3">
          <label class="">Attribute Type</label>
          <select class="custom-select" v-validate="{required: true}" v-model="data.type" name="type" placeholder="--select type--">
            <option disabled value="">--select type--</option>
            <option value="check">check</option>
            <option value="input">input</option>
          </select>
          <span class="text-danger invalid-feedback"  v-show="errors.has('type')">{{ errors.first('type') }}</span>
        </div>
        <div class="d-flex mt-3 justify-content-end">
          <b-button variant="primary" @click.prevent="editMode? update() : create()" type="button">{{editMode? 'Update':'Submit'}}</b-button>
        </div>
    </form>
</template>

<script>
export default {
    props:{
        productId:{
            type: Number,
            default: null
        },
        editItem:{
            type: Object,
            default: null
        },
        editMode:{
            type: Boolean,
            default: false
        }
    },
    data(){
        return{
            data: {
                name: "",
                type: "",
                product_id: this.productId
            },
        }
    },
    methods:{
        create() {
            this.$validator.validateAll().then(result => {
                if (!result) {this.alertError("Form not valid"); return }
                const formData = new FormData()
                this.$store.dispatch("changeLoaderValue", true)
                formData.append('data', JSON.stringify(this.data))
                this.$http.post("/attributes/create", formData)
                .then((response) => {
                    this.$store.dispatch("changeLoaderValue", false)
                    if(response.data.success){
                        this.$store.commit("productList/ADD_ATTRIBUTE", response.data.data.attribute)
                        this.resetForm();
                    }
                })
            })
        },
        update(){
           this.$validator.validateAll().then(result => {
                if (!result) {this.alertError("Form not valid"); return }
                const formData = new FormData()
                this.$store.dispatch("changeLoaderValue", true)
                formData.append('data', JSON.stringify(this.data))
                this.$http.post(`/attributes/${this.editItem.id}/update`,formData)
                .then((response) => {
                    this.$store.dispatch("changeLoaderValue", false)
                    if(response.data.success){
                        this.$store.commit("productList/UPDATE_ATTRIBUTE", response.data.data.attribute)
                        this.resetForm()
                    }
                })
            
            })
        },
        resetForm(){
            this.$validator.reset()
            this.$emit("closeMe")
        }
    },
    mounted(){
        if(this.editMode){
            this.data = JSON.parse(JSON.stringify(this.editItem))
        }
    }
}
</script>

<style>

</style>